import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { SIZE, Size } from 'models/Size';

import './CannotPreviewInBrowser.styles.scss';

type CannotPreviewInBrowserProps = {
  className?: string;
  size?: Size;
  title?: string;
  description?: string;
  showDescription?: boolean;
  actions?: ReactNode;
};

const CannotPreviewInBrowser: React.FC<CannotPreviewInBrowserProps> = (
  props,
) => {
  const { t } = useTranslation();

  const {
    children,
    className,
    actions,
    size = SIZE.BIG,
    showDescription = true,
    title = t('thisFileTypeCantBePreviewedInTheBrowser'),
    description = t('soWeTriggerDownload'),
  } = props;

  const classes = classNames('cannot-preview-in-browser', size, className);

  return (
    <div className={classes}>
      {children}
      <p>{title}</p>
      {showDescription && <p>{description}</p>}
      {actions}
    </div>
  );
};

export default CannotPreviewInBrowser;
